<template>
  <div class="elevatorListWrap mainPageBg">
    <div class="eleListContent">
      <div class="box" v-for="(v, i) in list" :key="i">
        <h4>{{ v.name }}</h4>
        <div
          class="commonWrap smallBox"
          v-for="(item, index) in v.elevatorDetailViewModelList"
          :key="index"
        >
          <el-row :gutter="20" style="padding: 20px">
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <div class="leftSamllBox">
                  <h6 style="width: 30%">{{ item.name }}</h6>
                  <el-button :type="item.active ? 'success' : 'info'" plain>{{
                    item.active ? "在线" : "离线"
                  }}</el-button>
                  <p style="margin-left: 35px">详细地址：{{ item.address }}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="rightSmallBox">
                  <el-button
                    type="warning"
                    plain
                    @click="changeDialogRepair(item)"
                    >总维修次数：{{ item.maintenanceTimes }}次</el-button
                  >
                  <el-button
                    :type="item.status == 0 ? 'success' : 'danger'"
                    plain
                    >{{ item.status == 0 ? "正常" : "告警" }}</el-button
                  >
                  <el-button type="primary" plain>详情</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog
      title="电梯维修历史"
      :visible.sync="dialogRepair"
      width="45%"
      v-if="dialogRepair"
    >
      <div style="width: 100%; height: 100%">
        <el-date-picker
          v-model="time"
          type="month"
          size="small"
          style="margin-bottom: 10px"
          :clearable="false"
          value-format="yyyy-MM"
          @change="changeTime"
        ></el-date-picker>
        <div
          id="mycharts"
          :style="{ width: '95%', height: '90%', margin: '0 auto' }"
        ></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      dialogRepair: false,
      list: [],
      time: dateFtt("yyyy-MM", new Date()),
      activeItem: {},
      chartsData: [],
    };
  },
  methods: {
    changeDialogRepair(item) {
      this.dialogRepair = true;
      this.time = dateFtt("yyyy-MM", new Date());
      this.activeItem = item;
      this.getMaintenance();
    },
    changeTime() {
      this.getMaintenance();
    },
    async getMaintenance() {
      let res = await api.subsystemGetMaintenance({
        date: this.time,
        id: this.activeItem.id,
      });
      // console.log("维修次数", res);
      if (res.status == 200) {
        this.chartsData = res.data;
        this.$nextTick(() => {
          this.drawLine();
        });
      }
    },
    drawLine() {
      if (document.getElementById("mycharts") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("mycharts"));
      let myChart = this.$echarts.init(document.getElementById("mycharts"));
      myChart.setOption({}, true);
      let data1 = [];
      for (let i = 0; i < this.chartsData.length; i++) {
        data1.push([this.chartsData[i].time, this.chartsData[i].value]);
      }
      let option = {
        backgroundColor: "#404a59",
        tooltip: {
          trigger: "item",
          formatter: "{a}<br/>{c}次",
        },
        calendar: [
          {
            top: 90,
            left: "center",
            range: this.time,
            orient: "vertical",
            cellSize: 70,
            itemStyle: {
              color: "#323c48",
              borderWidth: 1,
              borderColor: "#111",
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#000",
                width: 4,
                type: "solid",
              },
            },
            yearLabel: {
              margin: 60,
              show: false,
              color: "#ffffff",
            },
            monthLabel: {
              show: false,
              firstDay: 1,
              nameMap: "cn",
              margin: 30,
              color: "#ffffff",
            },
            dayLabel: {
              firstDay: 1,
              nameMap: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              color: "#ffffff",
            },
          },
        ],
        series: [
          {
            name: "维修次数",
            type: "effectScatter",
            coordinateSystem: "calendar",
            data: data1,
            symbolSize: function (val) {
              val = val[1] / 5;
              val = val < 5 ? 5 : Math.min(val, 30);
              return val;
            },
            itemStyle: {
              color: function (val) {
                let colors = "";
                if (val.data[1] == 60) {
                  colors = "#719df4";
                } else if (val.data[1] == 61) {
                  colors = "#2cdfff";
                } else if (val.data[1] == 77) {
                  colors = "#aa4fff";
                } else if (val.data[1] == 64) {
                  colors = "#ff680e";
                } else {
                  colors = "#f4e925";
                }
                return colors;
              },
            },
            label: {
              show: true,
              formatter(params) {
                return params.value[0].split("-")[2];
              },
              offset: [25, -20],
              color: "#ffffff",
            },
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
    async getLiftList() {
      let res = await api.subsystemGetLiftList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId,
      });
      // console.log(res);
      if (res.status == 200) {
        this.list = res.data;
      }
    },
  },
  created() {
    this.getLiftList();
  },
};
</script>

<style lang="scss" scoped>
.elevatorListWrap {
  overflow: auto;
  .eleListContent {
    width: 96%;
    margin: 0 auto;
    .box {
      margin-top: 20px;
      h4 {
        font-size: 22px;
        font-weight: 400;
        margin-left: 30px;
      }
      .smallBox {
        margin: 20px 0;
        .leftSamllBox {
          @include setFlexStart;
          h6 {
            font-weight: 400;
            font-size: 16px;
            text-align: center;
          }
        }
        .rightSmallBox {
          @include setFlexAround;
        }
      }
    }
    .box:last-child {
      margin-bottom: 20px;
    }
  }
  ::v-deep .el-dialog {
    height: 70% !important;
  }
  ::v-deep .el-dialog__body {
    height: 85% !important;
  }
}
</style>